import { AnimationEvent } from '@angular/animations';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  Optional,
} from '@angular/core';
import { Subject } from 'rxjs';
import { luiDrawerAnimations } from '../drawer-animations';

import { DrawerBaseDirective } from '../drawer-base.directive';

type DrawerBottomMode = 'push' | 'over';

@Component({
    selector: 'lui-drawer-bottom',
    templateUrl: './drawer-bottom.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [luiDrawerAnimations.drawerHeight],
    standalone: false
})
export class DrawerBottomComponent extends DrawerBaseDirective {
  @HostBinding('class') hostClass = 'lui-drawer-bottom';

  @HostBinding('class.lui-drawer-bottom-opened') get openedClass() {
    return this.opened;
  }

  // Mode properties
  @Input()
  get mode(): DrawerBottomMode {
    return this._mode;
  }
  set mode(value: DrawerBottomMode) {
    this._mode = value;
    // this._updateFocusTrapState();
    this._modeChanged.next();
  }
  private _mode: DrawerBottomMode = 'push';

  @HostBinding('class.lui-drawer-bottom-push') get pushClass() {
    return this.mode === 'push';
  }
  @HostBinding('class.lui-drawer-bottom-over') get overClass() {
    return this.mode === 'over';
  }

  readonly _modeChanged = new Subject<void>();

  // Animation
  @HostBinding('@height') get heightAnimation() {
    return { value: this._animationState, params: {} };
  }

  @HostListener('@height.start', ['$event']) _heightStarted(e: AnimationEvent) {
    this._animationStarted.next(e);
  }

  @HostListener('@height.done', ['$event']) _heightEnded(e: AnimationEvent) {
    this._animationEnd.next(e);
  }

  constructor(
    override _elementRef: ElementRef<HTMLElement>,
    @Optional() @Inject(DOCUMENT) override _doc: Document,
    override _platform: Platform
  ) {
    super(_elementRef, _doc, _platform);
  }
}
